module.exports = __webpack_public_path__ + "img/T2A_xs_01.abb90a54.png";